import { render, staticRenderFns } from "./SendRequest.vue?vue&type=template&id=fff66a24&scoped=true&"
import script from "./SendRequest.vue?vue&type=script&lang=js&"
export * from "./SendRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fff66a24",
  null
  
)

export default component.exports